import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";
import institutesData from "./institutesData";

const Institutes = () => {
  document.title = "Institutes | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="wrappermain">
      <div
        className="banner-image wrappermain"
        style={{
          backgroundImage: "url(" + Background_Member2 + ")",
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "25px 0",
        }}
      >
        <div className="banner-inner-breadcrumb">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/"}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Institutes
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <h2 className="mb-4 fw-bold text-center" style={{ fontSize: "2rem" }}>
          Approved Institutes for Academic Year 2026-27
        </h2>
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Name of Institute</th>
                <th>Private/Government</th>
                <th>Affiliated University Name</th>
                <th>Course Name</th>
                <th>Intake Seats (AY 2026-27)</th>
              </tr>
            </thead>
            <tbody>
              {institutesData.length ? (
                institutesData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.institute}</td>
                    <td>{item.type}</td>
                    <td>{item.university}</td>
                    <td>{item.course}</td>
                    <td>{item.seats}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No institutes available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Institutes;
